import {
  IPrMonteCarloDrawImperial,
  IWesleaConfigBatch, IWesleaResult,
  IWesleaResultBatch,
} from '@/modules/perRoad/interfaces/monteCarlo';
import { IPerRoadLayerImperial } from '@/modules/perRoad/interfaces/perRoad';
import { UnitSystem } from '@/interfaces/units';
import { createHistogramBins } from '@/modules/perRoad/lib/calculations/horizontalStrainDistribution';
import { defaultLineItems } from '@/modules/agencyCost/lib/unitCostsAndMeasures';

export const calculateSurfaceDeflectionDistributionFromResults = (
  // wesleaResults: IMonteCarloResultsObject[],
  draws: IPrMonteCarloDrawImperial[],
  wesleaConfigs: IWesleaConfigBatch,
  wesleaResults: IWesleaResultBatch,
  layerNum: number,
  unitSystem = UnitSystem.Imperial,
) => {
  const verticalDeflectionValues = draws.map((draw) => {
    const drawResults = wesleaResults[draw.id];
    const wesleaConfig = wesleaConfigs[draw.id];
    
    const criticalLocationResults: IWesleaResult[] = [];
    wesleaConfig.criticallocations
      .forEach((critLoc, i) => {
        if (critLoc.l === layerNum && critLoc.z === 0 && drawResults) {
          criticalLocationResults.push(drawResults[i]);
        }
      });
    
    const deflections: number[] = [];
    criticalLocationResults.forEach((result) => {
      if (result) {
        const def = result.normal_strain.z;
        // console.log('d', result.deflection);
        // console.log('S', result.normal_strain);
        // console.log('deflection?', def);
        deflections.push(-result.deflection.z);  
      }
    });
    return Math.max(...deflections);
  });
  
  const bins = createHistogramBins(verticalDeflectionValues);
  console.log('Deflection bins', bins);
  return bins;
};
